module.exports = __webpack_public_path__ + "html/section-company-quote_0237d771edd51d18de20f39a3f64eef7.html";


//////////////////
// WEBPACK FOOTER
// ./app/assets/html/landing-template/components/sections/section-company-quote.html
// module id = 1ps6
// module chunks = 92